<template>
  <div class="mt-4">
    <h1>Support Ticket</h1>
    <vs-table>
      <template #header>
        <vs-input v-model="search" border placeholder="Search">
          <template #icon>
            <span class="material-symbols-outlined"> search </span>
          </template>
        </vs-input>
        <div class="flex w-500">
          <vs-button
            @click="$router.push('/createHelp').catch(() => {})"
            class="create-manage-service"
            >Create Support Ticket</vs-button
          >
        </div>
      </template>
      <template #thead>
        <vs-tr style="width: 16.66%">
          <vs-th> Ticket_Id </vs-th>
          <vs-th> Date </vs-th>
          <vs-th> Priority </vs-th>

          <vs-th> Description </vs-th>
          <vs-th> Status </vs-th>
          <vs-th> Comment </vs-th>
        </vs-tr>
      </template>
      <template #tbody>
        <vs-tr
          :key="i"
          v-for="(tr, i) in $vs.getSearch(ticketList, search)"
          :data="tr"
        >
          <vs-td>
            {{ tr.id }}
          </vs-td>
          <vs-td>
            {{ tr.ticketDate | dateFormat }}
          </vs-td>
          <vs-td>
            {{ tr.priority }}
          </vs-td>

          <vs-td>{{ tr.problemDescription }}</vs-td>

          <vs-td>
            {{ tr.status }}
          </vs-td>
          <vs-td>
            {{ tr.statusDescription }}
          </vs-td>

          <!-- <vs-td>
            <div class="icon-group">
              <span class="material-symbols-outlined"> visibility </span>
              <span
                class="material-symbols-outlined"
                @click="downloadInvoice(tr.id)"
              >
                download
              </span>
              <span class="material-symbols-outlined"> mail </span>
            </div>
          </vs-td> -->
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  components: {},
  data: () => ({
    search: "",
    selectedMonth: "",
    usageOptions: [{ text: "Current Month", value: 0 }]
  }),
  computed: {
    isLogin() {
      return this.$store.getters["auth/isLogin"];
    },
    userInfo() {
      return this.$store.getters["auth/getUser"];
    },
    ticketList() {
      return this.$store.getters["dashboard/getTicketList"];
    }
  },

  methods: {
    dueDate(date) {
      return moment(date)
        .subtract(0, "month")
        .add(30, "day")
        .format("DD-MM-YYYY");
    }
    // async getEntityList(data) {
    //   try {
    //     const payload = {

    //       clientId: this.userInfo.clientId,

    //     };
    //     await this.$store.dispatch("dashboard/getTicketList", payload);
    //   } catch (e) {}
    // }
  },
  filters: {
    dateFormat: function(value) {
      if (!value) return "";

      return moment(value)
        .subtract(1, "month")
        .format("DD-MM-YYYY");
    }
  },
  async mounted() {
    if (!this.isLogin) this.$router.push("/login");
    await this.$store.dispatch(
      "dashboard/getTicketList",
      this.userInfo.clientId
    );
    console.log(this.ticketList);
  }
};
</script>
<style lang="scss" scoped>
.invoice-card {
  background: linear-gradient(135deg, #6572bb 0%, #2b3674 100%);
  width: 100%;
  padding: 20px;
  color: #ffffff;
  border-radius: 16px;
}
.amount {
  font-size: 22px;
  font-weight: 700;
  margin-top: 5px;
}
.pay-now {
  margin-left: 5rem;
  background: #fff;
  color: #2b3674;
  padding: 2px 10px;
}
.create-manage-service {
  margin-left: 12rem;
  background: #ff6914;
  color: #fff;
  padding: 2px 10px;
}
.w-300 {
  width: 300px;
  max-width: 40%;
  max-height: 35px;
}
@media (max-width: 300px) {
  .pay-now {
    margin-left: 3rem;
  }
}
</style>
